import { render } from "./WebcamStream.vue?vue&type=template&id=47bfe161"
import script from "./WebcamStream.vue?vue&type=script&lang=js"
export * from "./WebcamStream.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__